import WhatDoYouNeedHelpWithWithTreatmentPreferenceStep from '@/pages/members/pages/Onboarding/steps/WhatDoYouNeedHelpWithStep';

import { OnboardingNodeType, OnboardingStepType } from '../../steps/types';
import { OnboardingNode } from '../../types';

export const PRIMARY_SUBSTANCE_NODE: OnboardingNode = {
  index: 0,
  key: OnboardingNodeType.PRIMARY_SUBSTANCE,
  options: { countsTowardProgressBar: true },
  elements: [
    {
      uid: OnboardingStepType.PRIMARY_SUBSTANCE,
      component: (
        <WhatDoYouNeedHelpWithWithTreatmentPreferenceStep
          uid={OnboardingStepType.PRIMARY_SUBSTANCE}
          nodeType={OnboardingNodeType.PRIMARY_SUBSTANCE}
          displayName="Your Treatment Needs & Goals"
          actionButtonText="Next"
          showAllContent={true}
          showTreatableMatchesText={false}
          subheaderTextKey="choseTheOneThatBestFits"
        />
      )
    }
  ]
};
